export default __webpack_public_path__ + "assets/sutterSpace.6aa4bd4f.png";